// extracted by mini-css-extract-plugin
export default {"wrapper":"RatingBar_wrapper__WCjv7","numbers":"RatingBar_numbers__nQwn6"};